import React from 'react';
import Header from '../components/Header';
import Justice from "../assets/justice.webp";
import "../sass/pages/_legacy.scss";

export default function Legacy() {
  return (
    <>
        <Header />
        <main className='legacy'>
            <div className="justice">
                <img src={Justice} alt="Femme en robe tenant une figurine d'épée" />
            </div>
            <h2>Mentions Légales</h2>
            <h3>1. Éditeur du site </h3>
            <p className='center'>KABUYA Sina</p>
            <p className='center'>https://github.com/KABUYA-SINA</p>
            <p>Cette application a pour but de contribuer à l'amélioration continue des compétences, notamment dans le cadre des études.</p>

            <h3>2. Hébergeur </h3>
            <p className='center'>NETLIFY</p>
            <p className='center'>https://www.netlify.com/support/</p>
            <p className='center'>Siège : 2325 3rd Street, Suite 215, San Francisco, California 94107 Etats-Unis.</p>

            <h3>3. Propriété intellectuelle </h3>
            <p>
                Le contenu de ce site, incluant mais sans se limiter aux textes, images, logos et graphismes, 
                est protégé par les lois françaises et internationales sur la propriété intellectuelle. Les images 
                utilisées sur ce site proviennent de Unsplash, et sont utilisées conformément à leur licence. Toute reproduction, 
                même partielle, sans autorisation préalable de SINA est strictement interdite. Pour toute demande, merci de nous contacter sur GITHUB.
            </p>

            <h3>4. Responsabilité </h3>
            <p>
                SINA s'efforce d'assurer l'exactitude des informations publiées sur ce site. Cependant, 
                nous ne pouvons garantir l'absence d'erreurs, de virus ou d'interruptions. En conséquence, SINA décline toute 
                responsabilité pour les dommages directs ou indirects pouvant découler de l'accès ou de l'utilisation de ce site.
            </p>

            <h3>5. Liens externes </h3>
            <p>
                Des liens vers des sites tiers peuvent être présents. 
                SINA n'exerce aucun contrôle sur le contenu de ces sites et décline toute responsabilité à leur égard. 
                Nous vous encourageons à lire les mentions légales et la politique de confidentialité de chaque site que vous visitez.
            </p>

            <h3>6. Modifications des mentions légales </h3>
            <p>SINA se réserve le droit de modifier ces mentions légales à tout moment. Les utilisateurs sont donc invités à les consulter régulièrement.</p>

            <h3>7. Loi applicable </h3>
            <p>Les présentes mentions légales sont régies par le droit français. En cas de litige, les tribunaux français seront seuls compétents.</p>
        </main>
    </>
  )
}
